import React from "react";

const Forbidden = () => (
  <div style={{
    maxWidth: 500,
    margin: "80px auto",
    padding: 32,
    borderRadius: 16,
    background: "var(--ae-surface)",
    border: "2px solid #dc2626",
    boxShadow: "var(--ae-shadow-soft)",
    textAlign: "center"
  }}>
    <h1 style={{ color: "#dc2626", fontSize: 32, marginBottom: 16 }}>403 Forbidden</h1>
    <p style={{ color: "var(--ae-primary)", fontSize: 18, marginBottom: 24 }}>
      You do not have permission to access this page.<br />
      Please contact your administrator if you believe this is an error.
    </p>
    <a href="/dashboard" style={{ color: "var(--ae-accent)", fontWeight: 700, fontSize: 16 }}>
      Go to Dashboard
    </a>
  </div>
);

export default Forbidden;
